<template>
  <div class="c-choose-type-of-pix-key">
    <p class="pix-title">Informe a sua chave PIX</p>
    <div
      class="pix-item"
      v-for="(pixType, index) in pixTypes"
      :key="index"
      @click="selectType(pixType.type)"
    >
      <p>{{ pixType.name }}</p>
      <i class="fa fa-chevron-right"></i>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pixTypes: [
        {
          name: 'Celular',
          type: 'phone',
        },
        {
          name: 'E-mail',
          type: 'email',
        },
        {
          name: 'Chave aleatória',
          type: 'evp',
        },
      ],
    }
  },

  methods: {
    selectType(type) {
      this.$emit('pix-type', type)
    },
  },
}
</script>

<style lang="scss" scoped>
.c-choose-type-of-pix-key {
  .pix-title {
    margin-bottom: 40px;
    font-size: 20px;
    line-height: 100%;
    font-weight: bold;
    color: $gray-7;
  }

  .pix-item {
    display: flex;
    max-width: 448px;
    margin: 8px 0;
    padding: 24px;
    justify-content: space-between;
    align-items: center;
    border-radius: 8px;
    border: 1px solid $neutrallight;
    cursor: pointer;
    margin-bottom: 32px;
    p {
      color: $neutral;
      font-size: 18px;
      font-weight: 700;
    }

    &:hover {
      border: solid 1px $support;
      background-color: #f6ffff;

      i {
        color: $support;
      }
    }
  }
}
</style>
